import Card from "@/components/Card";
import Dropdown, { Item } from "@/components/form/Dropdown";
import { usePayContext } from "@/context/PayContext";
import { getYearBeforeCurrent, months } from "@/utils/date-format";
import React, { Dispatch, SetStateAction, useEffect } from "react";

const yearOptions: Item[] = getYearBeforeCurrent().map((year) => ({
  label: year.toString(),
  value: year.toString(),
}));

function PayPeriodSelector() {
  const { selectedMonth, setSelectedMonth, selectedYear, setSelectedYear } =
    usePayContext();

  const [monthsOptions, setMonthsOptions] = React.useState<Item[]>([]);
  useEffect(() => {
    const getMonthOptions = () => {
      let tmpMonthsOptions: Item[] = [];
      if (selectedYear === new Date().getFullYear().toString()) {
        // Get the current month and all months before it
        const currentMonthIndex = new Date().getMonth();
        const monthsBefore: Item[] = months
          .slice(0, currentMonthIndex + 1)
          .map((month) => ({
            label: month,
            value: month,
          }));
        tmpMonthsOptions = monthsBefore;
      } else {
        // Get all months
        tmpMonthsOptions = months.map((month) => ({
          label: month,
          value: month,
        }));
      }
      setMonthsOptions(tmpMonthsOptions);
    };
    getMonthOptions();
  }, [selectedYear]);
  return (
    <Card>
      <div className="flex gap-2 w-full flex-col p-5">
        <div className="font-bold text-2xl mb-4">Process Employee's Pay</div>
        <div className="mb-4 flex flex-col gap-3">
          <div className="font-bold  mt-2 text-xl">Select Pay Period</div>
          <div className="text-sm text-gray-500">
            Select the pay period you want to process.
          </div>
        </div>

        <div className="flex gap-2">
          <Dropdown
            label="Year"
            items={yearOptions}
            selectedString={selectedYear}
            setSelectedString={setSelectedYear}
          />

          <Dropdown
            label="Month"
            items={monthsOptions}
            selectedString={selectedMonth}
            setSelectedString={setSelectedMonth}
          />
        </div>
      </div>
    </Card>
  );
}

export default PayPeriodSelector;
